import { render, staticRenderFns } from "./CartCreator.vue?vue&type=template&id=cb22a070&"
import script from "./CartCreator.vue?vue&type=script&lang=ts&"
export * from "./CartCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports